<template>
  <div style="display: flex; justify-content: center">
    <div class="wizard-header">
      <div class="wizard-node" :class="nodeClass(1)" @click="irPara(1)">
        <div class="wizard-circle"><span>1</span></div>
        <div class="wizard-label">Upload do Arquivo</div>
      </div>

      <div class="wizard-line-active"></div>

      <div class="wizard-node" :class="nodeClass(2)" @click="podeIr(2) && irPara(2)">
        <div class="wizard-circle"><span>2</span></div>
        <div class="wizard-label">Validação do Arquivo</div>
      </div>

      <div :class="step === 3 ? 'wizard-line-active' : 'wizard-line'"></div>

      <div class="wizard-node" :class="nodeClass(3)" @click="podeIr(3) && irPara(3)">
        <div class="wizard-circle"><span>3</span></div>
        <div class="wizard-label">Upload Completo</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WizardSteps',
  props: {
    step: { type: Number, required: true },
    irPara: { type: Function, required: true },
    podeIr: {
      type: Function,
      default: () => () => true
    },
    errosPorStep: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    nodeClass(n) {
      const hasError = !!(this.errosPorStep && this.errosPorStep[n] === true)
      return {
        'is-active': this.step === n && !hasError,
        'is-complete': this.step > n,
        'is-error': hasError
      }
    }
  }
}
</script>

<style scoped>
.wizard-header {
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.wizard-node {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  min-width: 120px;
}

.wizard-label {
  font-weight: 400;
  margin-bottom: 4px;
  color: #73787F;
  text-align: center;
  font-size: 20px;
}

.wizard-circle {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: #73787F;
  border: 1px solid #ABAEB5;
  font-size: 22px;
  font-weight: 400;
  transition: all .2s ease;
  cursor: pointer;
  margin-right: 10px;
}

.wizard-line {
  flex: 1;
  height: 5px;
  background: #E2E2E4;
  margin: 0 4px 0 4px;
  border-radius: 20px;
}

.wizard-line-active {
  flex: 1;
  height: 5px;
  background: #0C75BE;
  margin: 0 4px 0 4px;
  border-radius: 20px;
}

.wizard-node.is-active .wizard-circle {
  background: #0C75BE;
  color: #fff;
  border-color: transparent;
}

.wizard-node.is-error .wizard-circle {
  background: #C0142F;
  color: #fff;
  border-color: transparent;
}

.wizard-node.is-error .wizard-label {
  color: #C0142F;
}

.wizard-node.is-active .wizard-label {
  color: #0C75BE;
}

.wizard-node.is-complete .wizard-circle {
  background: #0C75BE;
  color: #fff;
  border-color: transparent;
}

.wizard-node.is-complete .wizard-label {
  color: #0C75BE;
}

@media (max-width: 700px) {
  .wizard-label {
    font-size: 13px
  }

  .wizard-circle {
    width: 52px;
    height: 52px;
    font-size: 18px
  }
}
</style>
